import Home from "./components/Main.vue";

export default [
  {
    path: "/",
    name: "homeMain",
    component: Home,
    alias: ["/home"],
    meta: {
      isHome: true,
    },
    // component: () =>
    //   import(/* webpackChunkName: "view-home" */ `./components/Main.vue`).catch(
    //     (error) => {
    //       location.reload();
    //     }
    //   ),
  },
];
